import { OrderMethod } from '../../types/constants';
import { useCallback } from 'react';
import useStore from '../context/useStore';
import { OrderPreparationTime, StoreDetails } from '../../types/store';

export default function useOrderPreparationTime(store?: StoreDetails) {
  const { storeData: _storeData } = useStore();
  const storeData = store ?? _storeData;
  const { order_settings } = storeData;

  const getOrderMethodPrepTime = useCallback(
    (method: OrderMethod): OrderPreparationTime =>
      order_settings.preparation_time[method] ??
      order_settings.preparation_time[OrderMethod.Pickup],
    [order_settings.preparation_time],
  );

  const getOrderMethodPrepTimeLabel = useCallback(
    (method: OrderMethod): string => {
      const time = getOrderMethodPrepTime(method);

      return time.max ? `${time.min} - ${time.max} min` : `${time.min} min`;
    },
    [getOrderMethodPrepTime],
  );

  return {
    getOrderMethodPrepTime,
    getOrderMethodPrepTimeLabel,
  };
}
